module.exports = __webpack_public_path__ + "media/images/producers-e68733d2b9b8664f247b4eca3fc6d308.svg";